import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TreeNode } from 'src/app/core/tree/tree.interface';
import { LocalStorageService } from 'src/app/services/local-storage.service';

import { DatePipe } from '@angular/common';
import { Subject } from 'rxjs';
import * as _ from 'lodash';
import { environment } from 'src/environments/environment';
import { Session } from '../login/login';
import { AppTreeModules } from 'src/app/model/global-interface';


@Component({
    selector: 'app-dashboard',
    templateUrl: './dashboard.component.html',
    styleUrls: ['./dashboard.component.scss'],
    providers: [DatePipe],
    standalone: false
})
export class DashboardComponent implements OnDestroy, OnInit {

  data: TreeNode[] =  AppTreeModules;
  fetchDate: string = ''
  noData: boolean = false;
  prod: boolean = environment.production;
  stillLoading: boolean = false;
  private theEnd$ = new Subject<void>(); 

  constructor(
    private localStorage: LocalStorageService,
    private router: Router
  ) {

    this.localStorage.setTitolo('Dashboard');
  }

  ngOnInit(): void {
    let item = localStorage.getItem('M') || ''
    if (item == '') {
      setTimeout(() => {
        let menu = JSON.parse(this.localStorage.decrypt((localStorage.getItem('M') || '')))
        this.data = _.cloneDeep(menu);

      }, 500)
    } else
      this.data = _.cloneDeep(JSON.parse(this.localStorage.decrypt((item))))

    setTimeout(() => {
      let menu = JSON.parse(this.localStorage.decrypt((localStorage.getItem('M') || '')))
      this.data = _.cloneDeep(menu);

      if (this.data.length <= 0) {
        this.stillLoading = true;
      }
    }, 3000)
  }

  reload(){
    location.reload();
  }

  keyDwn(event: any, a: TreeNode) {
    console.warn(event);
    if (event.key == 'Enter') {
      this.router.navigate([a.route]);
    }
  }

  ngOnDestroy(): void {
    this.theEnd$.unsubscribe();
  }


  view(mdurl: string) {
    this.router.navigate([mdurl])
  }

  goToTestPage() {
    this.router.navigate(['/home/gestione-documenti/add', { uu: 'manjoAPI', pp: '/Gj3YwunwXGyqk+pVm2dqnXg9jvS5EqPxn35lPreCDc=' }]);
  }
}
